import React, { useEffect, useState } from 'react'
import { Box, Button, Loader, Modal, ProfileImage, Table, Text, TextField } from '../../components';
import { Col, DatePicker, Input, Pagination, Row, TimePicker, pagination } from 'antd';
import { Colors, Fonts, Utils } from '../../config';
import useMedia from 'use-media';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { HiOutlineSearch } from 'react-icons/hi';
import './style.css'
import { DisputeActions } from '../../store/actions';


const DisputeManagement = () => {

    const isTablet = useMedia({ minWidth: "768px" });
    const isMobile = useMedia({ minWidth: "550px" });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serviceUsers = useSelector((state) => state.serviceUsers);

    const [exportModal, setExportModal] = useState(false);
    const { isLoading, allDisputes } = useSelector(state => state?.DisputesManagementReducer);
    
    const [state, setState] = useState({
        limit: 10,
        offset: 0,
        page: 1,
        search: "",
        status: "",
        startDate: "",
        endDate: ""
    });

    useEffect(() => {
        if (state) {
            dispatch(DisputeActions.getAllDisputes(state))
        }
    }, [state])


    // status handler
    const handleStatusFilter = (checked, id) => {
        setState({
            ...state,
            offset: 0,
            status: checked,
        });
    };

    // search handler
    const handleSearchUsers = (e) => {
        setState({
            ...state,
            offset: 0,
            search: e.target.value.trimStart(),
        });
    };

    // pagination handler
    const handlePaginationChange = (pageNumber) => {
        let offset = (pageNumber - 1) * state.limit;
        setState({ ...state, offset: offset, page: pageNumber });
    };

    // date handler
    const dateHandler = (date, dateStrings) => {
        setState({ ...state, offset: 0, startDate: dateStrings[0], endDate: dateStrings[1] })
    }

    // export date handler
    const exportDataHandler = () => {
        dispatch(DisputeActions.exportDisputes(state, (res) => {
            window.open(res, "_blank");
            setExportModal(false)
        }))
    }

    // dispute detail page navigator
    const disputeDetail = (id) => {
        navigate(`/dispute-management-detail/${id}`)
    }

    return (
        <Box>
            <Row justify="space-between" align='middle'>
                <Col className="flex-start" lg={7} md={24}>
                    <Text.Heading
                        fontSize={24}
                        fontFamily={Fonts["Poppins-SemiBold"]}
                        color={Colors.Black}
                        fontWeight={600}
                        text={"Dispute Management"}
                    />
                </Col>
                <Col lg={17} md={24} sm={24} xs={24} className='filters'>
                    <Row className='filters-container'>
                        <Col className='filters-item'>
                            <Button.Basic className={'export-btn'} text={'Export Data'} onClick={() => setExportModal(true)} />
                        </Col>
                        <Col className='filters-item'>
                            <DatePicker.RangePicker className='range-picker-status' onChange={dateHandler} />
                        </Col>
                        <Col className='filters-item'>
                            <TextField.SelectField
                                placeholder="Select"
                                size="large"
                                id="provider-management-select"
                                type="text"
                                disabled={false}
                                required={false}
                                value={state?.status ? state?.status : "All Status"}
                                label=""
                                defaultValue="All Status"
                                error={false}
                                helperText=""
                                onChange={handleStatusFilter}
                                className='status-selector'
                                data={[
                                    {
                                        label: "All",
                                        value: "",
                                    },
                                    {
                                        label: "Pending",
                                        value: "pending",
                                    },
                                    {
                                        label: "Resolved",
                                        value: "resolved",
                                    },
                                ]}
                            />
                        </Col>
                        <Col className='filters-item'>
                            <TextField.CustomInput
                                placeholder="Search"
                                size="large"
                                // id="provider-management-search"
                                type="text"
                                disabled={false}
                                required={false}
                                value={state?.search}
                                label=""
                                defaultValue=""
                                error={false}
                                helperText=""
                                onChange={handleSearchUsers}
                                prefix={<HiOutlineSearch color={Colors.dropdownTextColor} />}
                                bgColor={Colors.dropdownBgColor}
                                color={Colors.dropdownTextColor}
                                className="user-search-field"
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row justify="space-between" className="mt-20">
                <Col span={24}>
                    {isLoading ? (
                        <Col className='loader table-loader-container'>
                            <Loader.Circular />
                        </Col>
                    ) : (
                        <>
                            <Table.AntDesignTable
                                className="user-table"
                                columns={[
                                    {
                                        title: "Disputed By",
                                        dataIndex: "disputeBy",
                                        key: "fullName",
                                        render: (text, record) => (
                                            <div className='profile-container' onClick={() => disputeDetail(record?.id)}>
                                                <ProfileImage
                                                    src={record?.disputeBy?.imageUrl}
                                                    alt="user"
                                                    className="service-user-img"
                                                />
                                                <span>{record?.disputeBy?.fullName?.length > 10 ? record?.disputeBy?.fullName?.slice(0, 11) + '...' : record?.disputeBy?.fullName}</span>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: "User",
                                        dataIndex: "disputeBy",
                                        key: "type",
                                        render: (text, record) => (
                                            <span>
                                                {record?.disputeBy?.type ? record?.disputeBy?.type : '-'}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Dispute On",
                                        dataIndex: "createdAt",
                                        key: "createdAt",
                                        render: (text, record) => (
                                            <span>
                                                {
                                                    Utils.formatTimestamp(record?.createdAt)
                                                }
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Price",
                                        dataIndex: "booking",
                                        key: "quotes",
                                        render: (text, record) => (
                                            <span>
                                                {record?.booking?.quotes?.length > 0 ? '£ ' + record?.booking?.quotes[0]?.price : 0}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Status",
                                        dataIndex: "status",
                                        key: "status",
                                        render: (text, record) => (
                                            <span>
                                                {
                                                    record?.status == 'PENDING' ?
                                                        <div className='pending-status'>{record?.status}</div>
                                                        :
                                                        <div className='resolved-status'>{record?.status}</div>}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Action",
                                        dataIndex: "adminAction",
                                        key: "adminAction",
                                        render: (text, record) => (
                                            <>
                                                {
                                                    record?.adminAction ?
                                                        record?.adminAction == 'FAVOR_USER' ?
                                                            <span className='favor-user'>In Favor of User</span>
                                                            :
                                                            record?.adminAction == 'FAVOR_PROVIDER' ?
                                                                <span className='favor-provider'>In Favor of Provider</span>
                                                                :
                                                                record?.adminAction == 'NO_FAVOR' ?
                                                                    <span className='no-favor'>No Favor</span>
                                                                    :
                                                                    <span className='partial'>Partial</span>
                                                        : '-'
                                                }
                                            </>
                                        ),
                                    },
                                ]}
                                data={allDisputes?.disputes}
                                pagination={true}
                                rowKey="key"
                            // loading={false}

                            />
                            <Row justify="center" className="mt-20">
                                <Col>
                                    <Pagination
                                        responsive="true"
                                        showLessItems="true"
                                        pageSize={state?.limit}
                                        current={state?.page}
                                        total={allDisputes?.count}
                                        onChange={handlePaginationChange}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                </Col>
            </Row>
            {
                exportModal &&
                <Modal.ConfirmationModal
                    title={""}
                    isModalVisible={exportModal}
                    heading={"Are you sure you want to export?"}
                    handleCancel={() => setExportModal(false)}
                    handleDelete={() => exportDataHandler()}
                >
                </Modal.ConfirmationModal>
            }
        </Box>
    )
}

export default DisputeManagement